import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { CatBtn, Container } from "../styledComponent/Common";
import { TableRowsLoader } from "../styledComponent/table/TableLoader";
import { TablePagination } from "../pagination/Pagination";
import { TableHeadCell } from "../styledComponent/table/TableCell";

const LockerAccessHistory = ({ lockerAccessHistory, loading, count, setSkip, setTake, take, skip }: { lockerAccessHistory?: Array<any> | undefined, loading: any, take: any, skip: any, setSkip: any, setTake: any, count: any }) => {
    return (
        <Container sx={{ width: "100%", marginTop: "15px" }}>
            <Box sx={{ width: "100%" }}>
                <Typography component="div" mb={2} sx={{ color: "black", fontWeight: "700", fontSize: "20px" }}>
                    Locker Access History
                </Typography>
                <LockerAccessHistoryTable lockerAccessHistory={lockerAccessHistory} loading={loading} count={count} setSkip={setSkip} setTake={setTake} take={take} skip={skip} />
            </Box>
        </Container>
    )
}

export default LockerAccessHistory

const LockerAccessHistoryTable = ({ lockerAccessHistory, loading, count, setSkip, setTake, take, skip }: { lockerAccessHistory: Array<any> | undefined, loading: any, take: any, skip: any, setSkip: any, setTake: any, count: any }) => {
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeadCell minwidth="5%">
                                SN
                            </TableHeadCell>
                            <TableHeadCell minwidth="40%">
                                Date
                            </TableHeadCell>
                            <TableHeadCell minwidth="35%">
                                Locker
                            </TableHeadCell>
                            <TableHeadCell minwidth="10%">
                                Check In
                            </TableHeadCell>
                            <TableHeadCell minwidth="10%">
                                Check Out
                            </TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? <TableRowsLoader rowsNum={5} colNum={8} />
                            : lockerAccessHistory && lockerAccessHistory?.length === 0 ? <TableRow>
                                <TableCell colSpan={5} align="center">No Data Found</TableCell>
                            </TableRow>
                                : lockerAccessHistory?.map((row, index) => (
                                    <TableRow key={index}
                                        sx={{
                                            "&:last-child td, &:last-child th": {
                                                border: 0,
                                            },
                                        }}
                                    >
                                        <TableCell sx={{ fontSize: '10px' }}>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                                        <TableCell sx={{ fontSize: '10px' }}>{row.date}</TableCell>
                                        <TableCell sx={{ fontSize: '10px' }}>{row.lockerNumber}</TableCell>
                                        <TableCell>
                                            <CatBtn bg="rgba(33, 150, 83, 0.2)" text="green" sx={{ fontSize: '10px' }}>
                                                {row.checkInTime}
                                            </CatBtn>
                                        </TableCell>
                                        <TableCell>
                                            <CatBtn bg="rgba(255, 76, 48, 0.2)" text="red" sx={{ fontSize: '10px' }}>
                                                {row.checkOutTime ?? "N/A"}
                                            </CatBtn>
                                        </TableCell>
                                    </TableRow>
                                ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {lockerAccessHistory && (lockerAccessHistory?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </Paper>
    );
}
